// extracted by mini-css-extract-plugin
module.exports = {"modal":"StatisticsFilterModal_modal__2lYgf","columns":"StatisticsFilterModal_columns__YktF5"};